import API from 'services/api';

export const updateCustomerSettings = ({ payload }: { payload: { languageId: number } }) =>
  API.put(`/api/profile/language-change`, payload);
